import React, { useCallback } from "react"
import { useSelector, useDispatch } from "react-redux"
import { AutocompleteField } from "@theguarantors/ui-kit-v2"
import { colors } from "@theguarantors/ui-kit-v2/dist/design-system/colors"
import { Building, MIN_AUTOCOMPLETE_CHARS } from "@theguarantors/frontend-core/dist/features/buildings"
import { LGQuestionnaireStore } from "../../../../../types/store.types"
import { getBuildings, EndpointType } from "@theguarantors/frontend-core/dist/features/buildings"
import { FieldProps } from "@theguarantors/ui-kit-v2/dist/components/form/Field.types"
import { useFormikContext } from "formik"
import { AddressFormValues } from "../AddressForm.types"
import { useHistoryActions } from "../../../../../history"
import { generateFullBuildingName } from "../AddressForm.utils"
import { FeatureFlag, useFeatureFlag } from "../../../../../hooks/use-feature-flag"
import ChevronArrowRight from "../../../../../components/icons/ChevronArrowRight.icon"
import { Version } from "@theguarantors/ui-kit-v2/dist/utils/form"

const getSuggestionValue = (suggestion: Building) => suggestion.name

export const BuildingsAutocompleteField: React.FC<FieldProps> = props => {
  const buildings = useSelector((state: LGQuestionnaireStore) => state.buildings.list)
  const dispatch = useDispatch()
  const { goToUnenrolledFormPage } = useHistoryActions()

  const fetchSuggestions = useCallback(
    (val: string) => (val.length >= MIN_AUTOCOMPLETE_CHARS ? dispatch(getBuildings(val, EndpointType.all)) : {}),
    [dispatch]
  )
  const { values } = useFormikContext<AddressFormValues>()
  const { buildingAddress: address, apartmentNumber: unit } = values
  const onSelectNewValue = useCallback(() => goToUnenrolledFormPage({ address, unit }), [
    address,
    unit,
    goToUnenrolledFormPage
  ])

  const [newGetStartedPage] = useFeatureFlag(FeatureFlag.NEW_GET_STARTED_PAGE)
  const newGetStartedPageFeatureFlag: boolean = newGetStartedPage === "on"

  const isSafari = navigator.userAgent.indexOf("Safari") !== -1 && navigator.userAgent.indexOf("Chrome") === -1
  const additionalProps = isSafari
    ? {}
    : {
        largeList: true,
        largeListHeight: 304,
        largeListItemCount: buildings.length,
        largeListItemSize: 84,
        largeListItemWidth: "100%"
      }

  const dontSeeYourBuilding = () => (
    <div
      style={{
        color: colors.v2_black,
        cursor: "pointer",
        fontSize: "1.6rem",
        fontWeight: "normal",
        fontFamily: "acid"
      }}
    >
      Don't see your building? <u>Add Your Building Address</u> <ChevronArrowRight />
    </div>
  )

  return (
    <AutocompleteField<Building>
      minChars={MIN_AUTOCOMPLETE_CHARS}
      suggestions={buildings}
      onRequest={fetchSuggestions}
      getSuggestionValue={getSuggestionValue}
      onSelectNewValue={onSelectNewValue}
      renderSuggestion={generateFullBuildingName}
      selectNewValueTemplate={newGetStartedPageFeatureFlag ? dontSeeYourBuilding() : undefined}
      version={newGetStartedPageFeatureFlag ? Version.v2 : undefined}
      {...additionalProps}
      {...props}
    />
  )
}
